import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "@qr-menu/ui/tokens.css";
import "@qr-menu/ui/layout.css";
import "@qr-menu/ui/primitives.css";
import "@qr-menu/ui/card.css";
import "@qr-menu/ui/table.css";
import "@qr-menu/ui/detail-list.css";
import "@qr-menu/ui/badge.css";
import "@qr-menu/ui/row-actions.css";
import "./styles.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element missing");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
